import Box from "@mui/material/Box";
import Skeleton from "../../../../../CommonComponents/Skeleton";

export const OACodingChallengSkeleton = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px",flex:1, }}>
      <Skeleton sx={{ width: "115px", height: "30px" }} animation="wave" />
      <Box
        sx={{
          height: "250px",
          padding: "16px 24px",
          borderRadius: "8px",
          bgcolor: "white",
        }}
      >
        <Box sx={{ height: "194px", /* width: "469.87px", */ padding: "8px 0px" }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "9px",
              }}
            >
              <Skeleton sx={{ height: "40px", width: "50%" }} />
              <Skeleton sx={{ height: "40px", width: "30%" }} />
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  );
};
